const supportedLocales = ["en", "es"] as const;
export type Locale = (typeof supportedLocales)[number];

export const SUPPORTED_LOCALES: readonly Locale[] = supportedLocales;

const DEFAULT_LOCALE: Locale = "en";

/**
 * Normalize an i18next `resolvedLanguage` (which may be a BCP 47 tag like
 * `en-US` or `es-AR`) down to the base language code, and fall back to the
 * default if the result isn't in the supported allow-list. Keeps the
 * controlled `<select>` from ending up with a value that has no matching
 * `<option>` (which renders as blank in some browsers).
 */
export function normalizeLocale(raw: string | undefined): Locale {
  if (!raw) return DEFAULT_LOCALE;
  const base = raw.toLowerCase().split("-")[0];
  return (supportedLocales as readonly string[]).includes(base) ? (base as Locale) : DEFAULT_LOCALE;
}
